import React from "react";
import { useForm } from "react-hook-form";

export function Step01({ onSubmit, store }) {
  const { handleSubmit } = useForm({
    defaultValues: store,
  });

  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <p className="font-medium text-lg text-left mt-4">
        If you have just separated from your partner, we understand how
        overwhelming it can be for you.
      </p>
      <p className="font-medium text-lg text-left mt-4">
        It can be difficult to understand what to do next.
      </p>
      <section>
        <p className="font-medium text-lg text-left m-0">
          You might have lots of questions such as:
        </p>
        <ul className=" font-medium text-lg list-disc pl-10 mt-2">
          <li>How do you divide the assets?</li>
          <li>How does divorce work?</li>
          <li>What's the process?</li>
          <li>How long does it take?</li>
        </ul>
        <p className="font-medium text-lg text-left mt-4">
          We will provide you with a free Action Plan on what steps you need to
          take to move forward positively with your separation.
        </p>
      </section>
    </form>
  );
}
